import { type AxiosError, HttpStatusCode } from "axios";

import { cleanUpUserSession } from "@/utils";

export const errorResponseInterceptor = async (error: AxiosError) => {
  if (
    error.response &&
    error.response.status === HttpStatusCode.Unauthorized &&
    !error.config?.baseURL?.includes("/logout")
  ) {
    cleanUpUserSession();
    window.location.href = "/login?redirect=" + encodeURIComponent(window.location.pathname);
  }

  return Promise.reject(error);
};
